export const ROUTES = {
    HOMEPAGE_ROUTE: '/',
    SEARCH_ROUTE: '/search'
}